class UpdateService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  updateServer() {
    return this.apiService.get('/api/v1/update');
  }

  getUpdateStatus() {
    return this.apiService.get('/api/v1/update-status');
  }
}

export default UpdateService;